import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import jwtDecode from 'jwt-decode'
import { adminUserActions } from '../../../redux/actions/admin/admin-user'
import get from 'lodash.get'
import { adminLoginRefresh } from '../../../api'

function AuthenticationWrapper ({ children }) {
  const dispatch = useDispatch()
  const adminUser = useSelector((state) => state.adminUser)

  const [isValid, setIsValid] = useState(false)

  useEffect(() => {
    const tokenRefresh = () => {
      const payload = decodeJwtToken(get(adminUser, 'user.tokens.token', ''))
      if (!payload) {
        dispatch(adminUserActions.logout())
        return
      }
      if (isJwtExpired(payload.exp, 0)) {
        dispatch(adminUserActions.logout())
        return
      } else {
        setIsValid(true)
      }
      if (isJwtExpired(payload.exp, 1000 * 60 * 10)) {
        refresh().then(() => {
          setIsValid(true)
        }).catch((reason) => {
          console.log(reason)
        })
      }
    }

    const decodeJwtToken = (token) => {
      try {
        return jwtDecode(token)
      } catch (e) {
        return null
      }
    }

    const refresh = async () => {
      const refreshToken = get(adminUser, 'user.tokens.refreshToken', null)
      const { fetchPromise } = adminLoginRefresh(refreshToken)
      let tokens = await fetchPromise
      dispatch(adminUserActions.setTokens(tokens.token, tokens.refreshToken))
    }

    const isJwtExpired = (exp, withinNextMilliseconds = 0) => {
      if (isNaN(exp)) {
        return true
      }
      const expiration = new Date(exp * 1000)
      const now = new Date()
      return expiration.getTime() - now.getTime() < withinNextMilliseconds
    }

    const payload = decodeJwtToken(get(adminUser, 'user.tokens.token', ''))
    if (!payload) {
      dispatch(adminUserActions.logout())
      return
    }
    if (isJwtExpired(payload.exp, 0)) {
      dispatch(adminUserActions.logout())
      return
    } else {
      setIsValid(true)
    }

    const timer = window.setInterval(() => {
      tokenRefresh()
    }, 1000 * 60)
    setIsValid(true)

    return () => {
      clearInterval(timer)
    }
  }, [dispatch, adminUser])

  return (
    <React.Fragment>{isValid ? children : null}</React.Fragment>
  )
}

export default AuthenticationWrapper
